<div class="header-bar">
  <h1>B2C Discount Codes</h1>
</div>
<div class="content-container">
  <!--  <div class="style2023 mb-3">-->
  <!--    <div class="input-group">-->
  <!--      <div class="input-group-prepend group-label">Customer</div>-->
  <!--      <div class="input-group-item">-->
  <!--        <p-dropdown-->
  <!--          [options]="customerOptions"-->
  <!--          [styleClass]="'input-group-filter'"-->
  <!--          [(ngModel)]="filterCustomer"-->
  <!--          class="filter-dropdown input-group-filter"-->
  <!--        ></p-dropdown>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </div>-->

  <form (ngSubmit)="search()" style="width: 100%">
    <div class="ui-g filterPanel form-group">
      <div class="ui-g-12 ui-md-4 ui-lg-2">
        <span class="md-inputfield filterItem">
          <input name="Code" type="text" pInputText [(ngModel)]="filterVal.filters.code.value" />
          <label>Code</label>
        </span>
      </div>

      <div class="ui-g-12 ui-md-4 ui-lg-2">
        <button pButton type="submit" label="Search"></button>
        <button pButton type="button" label="Clear" (click)="clearFilter()"></button>
      </div>
    </div>
  </form>

  <div class="ui-table ui-table-hoverable-rows">
    <div class="ui-table-wrapper">
      <div class="text-center p-4" style="font-size: 20px" *ngIf="loading">
        <i class="fa-15x fa fa-spin fa-spinner"></i> Loading
      </div>
      <div>
        <p-table
          class="table w-100"
          *ngIf="!loading"
          [rowsPerPageOptions]="[10, 25, 50, 100]"
          [pageLinks]="5"
          [responsive]="true"
          [value]="filtered(orderDiscountCodes)"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="code">Code</th>
              <!--              <th pSortableColumn="organisation?.name">Customer</th>-->
              <th pSortableColumn="urgent">Urgent</th>
              <th pSortableColumn="nonUrgent">NonUrgent</th>
              <th pSortableColumn="discountPercentage">% Discount</th>
              <th pSortableColumn="discountAmount">&pound; Discount</th>
              <th pSortableColumn="startDate">Starts</th>
              <th pSortableColumn="endDate">Ends</th>
              <th>Max Uses</th>
              <th>Uses</th>
              <th>Referrer</th>
              <th>Added By User</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="11" class="text-center"><div class="p-4">No discount codes</div></td>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-itemUntyped>
            <ng-container *ngIf="asDiscountCode(itemUntyped) as item">
              <tr
                class="ui-selectable-row"
                [class.ui-state-highlight]="selectedDiscount?.id == item.id"
                (dblclick)="initEditDiscount(item)"
                (click)="discountSelected(item)"
              >
                <td class="text-center">{{ item.code }}</td>
                <!--              <td>{{ item.organisation?.name || 'ALL CUSTOMERS' }}</td>-->
                <td class="text-center checked-or-not">
                  <i
                    class="fa fa-15x"
                    [class.fa-check]="item.urgent"
                    [class.fa-times]="!item.urgent"
                  ></i>
                </td>
                <td class="text-center checked-or-not">
                  <i
                    class="fa fa-15x"
                    [class.fa-check]="item.nonUrgent"
                    [class.fa-times]="!item.nonUrgent"
                  ></i>
                </td>
                <td class="text-center">
                  <span *ngIf="item.discountPercentage > 0"> {{ item.discountPercentage }}% </span>
                  <span *ngIf="!item.discountPercentage > 0">-</span>
                </td>
                <td class="text-center">
                  <span *ngIf="item.discountAmount > 0">&pound;{{ item.discountAmount }}</span>
                  <span *ngIf="!item.discountAmount > 0">-</span>
                </td>
                <td class="text-center">{{ item.startDate | date : 'dd/MM/yyyy' }}</td>
                <td class="text-center">{{ item.endDate | date : 'dd/MM/yyyy' }}</td>
                <td class="text-center">{{ item.maxUses || 'Unlimited' }}</td>
                <td class="text-center">{{ item.timesUsed }}</td>
                <td class="text-center">{{ item.referrerDescription }}</td>
                <td class="text-center">{{ item.addedByUser }}</td>
              </tr>
            </ng-container>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
  <div class="text-right mt-3">
    <!-- delete button is hidden until it's decided whether to implement it -->
    <button
      class="ui-button-danger transparent-bg"
      pButton
      label="Delete"
      [disabled]="selectedDiscount == null || selectedDiscount?.timesUsed > 0"
      [hidden]="true"
      (click)="deleteDiscountCode()"
    ></button>
    <button
      class="ui-button-tertiary transparent-bg"
      [disabled]="selectedDiscount == null"
      pButton
      label="Edit"
      (click)="initEditDiscount(this.selectedDiscount)"
    ></button>
    <button
      class="ui-button-primary"
      pButton
      label="Create"
      (click)="initCreateDiscount()"
    ></button>
  </div>
</div>

<p-dialog [(visible)]="showEditDiscountDialog" [style]="{ width: '500px' }">
  <p-header>Discount Code</p-header>

  <form [formGroup]="editForm">
    <div class="mb-3 w-full dcode-form">
      <div class="grid w-full mb-2">
        <div class="col-4">Code:</div>
        <div class="col"><input pInputText type="text" formControlName="code" required /></div>
      </div>

      <!--      <div class="grid w-full mb-2">-->
      <!--        <div>Customer:</div>-->
      <!--        <div>-->
      <!--          <p-dropdown-->
      <!--            name="customers"-->
      <!--            [options]="customerOptions"-->
      <!--            formControlName="organisationId"-->
      <!--            styleClass="filterItem"-->
      <!--            [style]="{ width: '100%' }"-->
      <!--          ></p-dropdown>-->
      <!--        </div>-->
      <!--      </div>-->

      <div class="grid w-full mb-2">
        <div class="col-4">Short Description:</div>
        <div class="col"><input pInputText formControlName="description" [maxlength]="50" /></div>
      </div>

      <div class="grid w-full mb-2">
        <div class="col-4">For Urgent Moves:</div>
        <div class="col"><p-inputSwitch formControlName="urgent"></p-inputSwitch></div>
      </div>

      <div class="grid w-full mb-2">
        <div class="col-4">For NonUrgent Moves:</div>
        <div class="col"><p-inputSwitch formControlName="nonUrgent"></p-inputSwitch></div>
      </div>

      <div class="grid w-full mb-2">
        <div class="col-4">Discount Mode:</div>
        <div class="col">
          <p-dropdown
            [ngModelOptions]="{ standalone: true }"
            [options]="discountModeOptions"
            [(ngModel)]="discountCodeMode"
            (onChange)="discountCodeModeChange($event)"
          ></p-dropdown>
        </div>
      </div>

      <div class="grid w-full mb-2" *ngIf="discountCodeMode == DiscountCodeMode.Percent">
        <div class="col-4">Discount Percentage:</div>
        <div class="col">
          <input
            pInputText
            type="text"
            formControlName="discountPercentage"
            (keydown)="inputHelper.allowNumberInputKey($event, false)"
            (keyup)="inputHelper.fixDigits($event.target)"
          />
          <div
            class="mt-2 text-red-400"
            *ngIf="editForm?.controls?.discountPercentage.errors?.withinRange"
          >
            Discount Percentage must be between {{ settings?.minimumDiscountCodePercentage }} and
            {{ settings?.maximumDiscountCodePercentage }}
          </div>
        </div>
      </div>

      <div class="grid w-full mb-2" *ngIf="discountCodeMode == DiscountCodeMode.Amount">
        <div class="col-4">Discount Amount:</div>
        <div class="col">
          <input
            pInputText
            type="text"
            formControlName="discountAmount"
            (keydown)="inputHelper.allowNumberInputKey($event, true)"
            (keyup)="inputHelper.fixDigits($event.target)"
          />
          <div
            class="mt-2 text-red-400"
            *ngIf="editForm?.controls?.discountAmount.errors?.withinRange"
          >
            Discount Percentage must be between {{ settings?.minimumDiscountCodeAmount }} and
            {{ settings?.maximumDiscountCodeAmount }}
          </div>
        </div>
      </div>

      <div class="grid w-full mb-2">
        <div class="col-4">Start Date:</div>
        <div class="col">
          <p-calendar
            formControlName="startDateDisplay"
            appendTo="body"
            dateFormat="dd/mm/yy"
          ></p-calendar>
        </div>
      </div>

      <div class="grid w-full mb-2">
        <div class="col-4">End Date:</div>
        <div class="col">
          <p-calendar
            formControlName="endDateDisplay"
            appendTo="body"
            dateFormat="dd/mm/yy"
          ></p-calendar>
        </div>
      </div>

      <div class="grid w-full mb-2">
        <div class="col-4">Max Uses:</div>
        <div class="col">
          <input
            pInputText
            type="text"
            formControlName="maxUses"
            (keydown)="inputHelper.allowNumberInputKey($event, false)"
            (keyup)="inputHelper.fixDigits($event.target)"
          />
        </div>
      </div>
    </div>
  </form>

  <p-footer>
    <div class="text-right">
      <button
        pButton
        label="Cancel"
        class="ui-button-tertiary"
        (click)="showEditDiscountDialog = false"
      ></button>
      <button pButton label="Save" (click)="saveDiscount()" [disabled]="!editForm.valid"></button>
    </div>
  </p-footer>
</p-dialog>
